'use client';
import Script from 'next/script';
import { useEffect, useRef, useState } from 'react';
import './adpanel.css';
import { Box } from '@styled-system/jsx';
import { zIndexTokens } from '@panda-css-token/z-index';

type Props = {};

export const MobileOverlayAdWithAdx = ({}: Props) => {
  const [isPanelVisible, setIsPanelVisible] = useState(true);
  const adAreaRef = useRef<HTMLDivElement>(null);
  const adAreaMcRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // microadCompassのグローバルオブジェクトを初期化
    if (typeof window !== 'undefined') {
      (window as any).microadCompass = (window as any).microadCompass || {};
      (window as any).microadCompass.queue =
        (window as any).microadCompass.queue || [];
    }

    // compass.js スクリプトの読み込み
    const loadCompassScript = () => {
      const existingScript = document.querySelector('#microad-compass-script');
      if (!existingScript) {
        const script = document.createElement('script');
        script.id = 'microad-compass-script';
        script.type = 'text/javascript';
        script.charset = 'utf8';
        script.src = '//j.microad.net/js/compass.js';
        script.async = true;
        script.addEventListener('load', () => {
          if (
            typeof (window as any).microadCompass !== 'undefined' &&
            (window as any).microadCompass.AdInitializer
          ) {
            new (window as any).microadCompass.AdInitializer().initialize();
          }
        });
        document.body.append(script);
      }
    };

    loadCompassScript();

    // 広告の表示ロジック
    const setupAds = () => {
      if (adAreaRef.current && adAreaMcRef.current) {
        if (Math.random() < 0.5) {
          // Google Ad (GPT)
          const gptDiv = document.createElement('div');
          gptDiv.id = 'div-gpt-ad-1744183959825-0';
          adAreaRef.current.append(gptDiv);

          const gptScript = document.createElement('script');
          gptScript.text =
            "googletag.cmd.push(function() { googletag.display('div-gpt-ad-1744183959825-0'); });";
          gptDiv.append(gptScript);

          // googletagオブジェクトが定義されていない場合のために、GPTのスクリプトもここで読み込むことを検討
          // (通常はheadタグなどで事前に読み込まれることが多いです)
          if (!(window as any).googletag) {
            const googletagScript = document.createElement('script');
            googletagScript.async = true;
            googletagScript.src =
              'https://www.googletagservices.com/tag/js/gpt.js';
            document.head.append(googletagScript);
            (window as any).googletag = (window as any).googletag || {
              cmd: [],
            };
          }
        } else {
          // microadCompass Ad
          const mcDiv = document.createElement('div');
          mcDiv.id = 'fd905be452c60ce2c2f2f2b03b867cc9';
          adAreaMcRef.current.append(mcDiv);

          const mcScript = document.createElement('script');
          mcScript.text =
            'microadCompass.queue.push({"spot": "fd905be452c60ce2c2f2f2b03b867cc9"});';
          mcDiv.append(mcScript);
        }
      }
    };

    setupAds();

    // コンポーネントのアンマウント時にスクリプトをクリーンアップする必要がある場合はここに追加
    return () => {
      // 例えば、追加したdiv要素を削除するなど
      // ただし、広告スクリプト自体がグローバルに影響するため、完全にクリーンアップするのは難しい場合が多い
    };
  }, []); // 空の依存配列はマウント時に一度だけ実行されることを意味します

  const handleClosePanel = () => {
    setIsPanelVisible(false);
  };

  if (!isPanelVisible) {
    return null; // パネルが非表示の場合、何もレンダリングしない
  }

  return (
    <>
      <Script
        id="i-mobile-gpt-tag"
        async
        src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
      />
      <Script id="i-mobile-gpt-tag-ads">
        {`window.googletag = window.googletag || {cmd: []};
  googletag.cmd.push(function() {
    var REFRESH_KEY = 'refresh';
    var REFRESH_VALUE = 'true';
    googletag.defineSlot('/9176203,22820604674/1895356', [[320, 75], [320, 100], 'fluid', [320, 50], [320, 120]], 'div-gpt-ad-1744183959825-0').setTargeting(REFRESH_KEY, REFRESH_VALUE).addService(googletag.pubads());
    var SECONDS_TO_WAIT_AFTER_VIEWABILITY = 30;
    googletag.pubads().addEventListener('impressionViewable', function(event) {
      var slot = event.slot;
      if (slot.getTargeting(REFRESH_KEY).indexOf(REFRESH_VALUE) > -1) {
        window.imgoogletagrefresh = setTimeout(function() {
          googletag.pubads().refresh([slot]);
        }, SECONDS_TO_WAIT_AFTER_VIEWABILITY * 1000);
      }
    });
    googletag.pubads().enableSingleRequest();
    googletag.pubads().collapseEmptyDivs(); //空のdivを閉じる
    googletag.enableServices();
  });`}
      </Script>
      <Box
        id="im_panel"
        position="fixed"
        bottom={{
          base: 'calc(env(safe-area-inset-bottom) + 54px)',
          lg: '0',
        }}
        right="0"
        width="100%"
        background="rgba(0, 0, 0, 0)"
        textAlign="center"
        transform="translate3d(0, 0, 0)"
        overflow="hidden"
        style={{
          zIndex: zIndexTokens.overlayAdsContainer.value - 1,
        }}
      >
        <button
          type="button"
          id="im_panel_close"
          className="btn_parts_sp" // CSSファイルに定義されたクラスを使用
          onClick={handleClosePanel}
        ></button>
        <Box
          id="ad_area"
          ref={adAreaRef}
          width="calc(100% - 20px)"
          overflow="hidden"
          float="right"
        />
      </Box>
      <Box
        id="ad_area_mc"
        ref={adAreaMcRef}
        position="fixed"
        bottom={{
          base: 'calc(env(safe-area-inset-bottom) + 54px)',
          lg: '0',
        }}
        left="0"
        right="0"
        style={{
          zIndex: zIndexTokens.overlayAdsContainer.value - 1,
        }}
      />
    </>
  );
};
